import PortfolioNavigation from '@common/Components/PortfolioNavigation.vue';
import { CurrencyDenomination } from '@common/types';
import { ICommandBase } from '@Quest/cqrs';
import PnlViewer from '@Quest/Pnls/Components/PnlViewer.vue';
import { PnlTemplateReadModel } from '@Quest/Pnls/Domain/readmodels';
import PortfolioScenarioNavigation from '@Quest/PortfolioScenarios/Components/PortfolioScenarioNavigation.vue';
import { OptimizeSelectionCommandV1, UpdatePortfolioScenarioCommandV1 } from '@Quest/PortfolioScenarios/Domain/commands-core';
import PortfolioScenariosQueries from '@Quest/PortfolioScenarios/Domain/queries-vue-component';
import { PnlPageReadModel, PortfolioScenarioPnlReadModel } from '@Quest/PortfolioScenarios/Domain/readmodels';
import { Component, mixins } from 'vue-facing-decorator';


@Component({
    components: {
        PortfolioNavigation, PortfolioScenarioNavigation, PnlViewer
    }
})
export default class PnlPage extends mixins(PortfolioScenariosQueries)
{
    get workspaceId(): number { return Number.parseInt(this.$route.params.workspaceId); }
    get tchProjectId(): number { return Number.parseInt(this.$route.params.tchProjectId); }
    get scenarioId() { return this.$route.params.scenarioId; }

    rm: PnlPageReadModel | null = null;


    get selectedPnl(): PnlTemplateReadModel | null
    {
        if (this.rm!.PnlTemplates)
        {
            return (this.rm!.PnlTemplateId ? this.rm!.PnlTemplates.find(a => a.Id === this.rm!.PnlTemplateId) : this.rm!.PnlTemplates.find(a => a.IsDefault === true)) ?? null;
        }

        return null;
    }

    reloadPnl()
    {
        if (this.rm?.PnlTemplateId)
        {
            this.runPortfolioScenarioPnlQueryV1(this.workspaceId, this.tchProjectId, this.scenarioId, this.rm.ApplyBenefitsConfidenceFactor, this.rm.PnlTemplateId, this.rm.Denomination)
            this.rm.Report = null;
        }
    }

    toggleBenefitsConfidenceFactor()
    {
        this.rm!.ApplyBenefitsConfidenceFactor = !this.rm!.ApplyBenefitsConfidenceFactor;
        this.reloadPnl();
    }

    setDenomination(d: CurrencyDenomination)
    {
        this.rm!.Denomination = d;
        this.reloadPnl();
    }

    toggleCagrVisible()
    {
        this.rm!.CagrVisible = !this.rm!.CagrVisible;
    }

    switchPnlTemplate(pnlId: string | null)
    {
        this.rm!.PnlTemplateId = pnlId;
        this.reloadPnl();
    }


    mounted()
    {
        document.title = "Portfolio Plan - P&L";
        this.runPnlPageQueryV1(this.workspaceId, this.tchProjectId, this.scenarioId);
    }

    onSetModel(model: any, modelName: string) 
    {
        if (modelName === "PnlPageReadModel")
        {
            this.rm = model as PnlPageReadModel;
        }
        else if (modelName === "PortfolioScenarioPnlReadModel")
        {
            this.rm!.Report = model as PortfolioScenarioPnlReadModel;
        }
    }

    onCommandSucceed(cmd: ICommandBase, correlationId: string)
    {
        if (UpdatePortfolioScenarioCommandV1.matchType(cmd))
        {
            this.runPnlPageQueryV1(this.workspaceId, this.tchProjectId, this.scenarioId);
        }
        else if (OptimizeSelectionCommandV1.matchType(cmd))
        {
            this.runPnlPageQueryV1(this.workspaceId, this.tchProjectId, this.scenarioId);
        }
    }
}